let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kfmI5")).then(() => parcelRequire('JDJjp'));